import hydrate from 'widget/hydrate';
import LiveProfile from './LiveProfile';
import type { ComponentProps } from './types';

hydrate<ComponentProps>(LiveProfile);
